import React from "react";
import styled from "styled-components";

// components
import Row1 from "./Layout/Row1/index";
import Row2 from "./Layout/Row2/index";

//styles
import breakpoints from "core/breakpoints";
const TabletDesktopStyled = styled.div`
    padding: 0px 1.5rem;

    display: none;
    @media (min-width: ${breakpoints.tablet.rem}) {
        display: block;
    }
`;

// component
export const TabletDesktop = () => {
    return (
        <TabletDesktopStyled>
            <Row1 />
            <Row2 />
        </TabletDesktopStyled>
    );
};

export default TabletDesktop;
